import { StateSchema } from '../../../../../app/providers/StoreProvider/config/StateSchema';

export const getUserLoading = (state: StateSchema) => state.user.loading;
